
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/notice-configuration",
      function () {
        return require("private-next-pages/companies/notice-configuration/index.tsx");
      }
    ]);
  